import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Phone, Sparkles } from 'lucide-react';

export const WhatToExpect = () => {
  const steps = [
    {
      icon: FileText,
      number: "01",
      title: "Apply",
      description: "Fill out a quick application form so I can understand where you are and what you're looking for."
    },
    {
      icon: Phone,
      number: "02",
      title: "Free Discovery Call",
      description: "We'll hop on a call to explore your goals, challenges, and whether we're a good fit to work together."
    },
    {
      icon: Sparkles,
      number: "03",
      title: "Your Program",
      description: "If it feels right for both of us, we'll create a personalized program and begin your transformation journey."
    }
  ];

  return (
    <section className="py-20 md:py-32 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-[#333333] mb-4">
            What to Expect
          </h2>
          <p className="text-lg md:text-xl text-[#666666] max-w-2xl mx-auto">
            Three simple steps from where you are now to where you want to be.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.15 }}
                className="text-center relative"
              >
                <div className="mb-6">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-[#8B6F47] text-white rounded-full mb-4">
                    <Icon size={32} />
                  </div>
                  <div className="text-6xl font-bold text-[#f9f8f3] absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-4 -z-10">
                    {step.number}
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-[#333333] mb-3">
                  {step.title}
                </h3>
                <p className="text-base text-[#666666] leading-relaxed">
                  {step.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
